import { useState } from 'react';
import { DataTable, Page, Card } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsUserTypesPage() {
  const [usertypes, setUsertypes] = useLookupStore((state) => [state.usertypes, state.setUsertypes]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({ Gebruikertype: { type: 'text', label: 'User type', max: '255', value: '' } });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/usertypes';
  const title = 'User types';

  const rows = usertypes.map((item) => [item.Gebruikertype, getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.GebruikertypeID)]);

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      primaryAction={{ content: 'Add user type', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId) }}
    >
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setUsertypes}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable stickyHeader increasedTableDensity verticalAlign="middle" columnContentTypes={['text', 'numeric']} headings={[<b>User type</b>, <b>Edit</b>]} rows={rows} />
      </Card>
    </Page>
  );
}
